import React, { useState, useEffect } from "react";
//import { useParams, useNavigate } from "react-router-dom";
import API_URL from "../../functions/config";

const UpdateProfile = () => {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");

    const [locationRadius, setLocationRadius] = useState(100);

    const [planType, setPlanType] = useState("Free");
    const [companyName, setCompanyName] = useState("");
    const [logo, setLogo] = useState("");
    const [logoScale, setLogoScale] = useState(100);

    const [phone, setPhone] = useState("");
    const [whatsapp, setWhatsapp] = useState("");

    const [checkinTime, setCheckinTime] = useState("");
    const [checkoutTime, setCheckoutTime] = useState("");

    const [longitude, setLongitude] = useState("");
    const [latitude, setLatitude] = useState("");

    const [timezone, setTimezone] = useState("");

    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);


    //Upload Logo
    const handleLogoUpload = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const reader = new FileReader();

        reader.onloadend = () => {
            setLogo(reader.result);
        };

        reader.readAsDataURL(file);
    };



    // Getting Location
    const [Updated, setUpdated] = useState(false);
    const [gettingLocation, setGettingLocation] = useState(false);

    const copyLocation = () => {
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by this browser.");
            return;
        }

        // Disable button
        setGettingLocation(true);
        setUpdated(false);

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                // Show location in fields
                setLatitude(lat);
                setLongitude(lng);

                // Copy location
                const locationText = `Latitude: ${lat}, Longitude: ${lng}`;

                try {
                    await navigator.clipboard.writeText(locationText);

                    setUpdated(true);

                    setTimeout(() => {
                        setUpdated(false);
                    }, 2000);
                } catch (error) {
                    console.log("Copy error:", error);
                }

                // Enable button again
                setGettingLocation(false);
            },
            (error) => {
                console.log("Location error:", error);

                alert("Unable to get your current location.");

                // Enable button again
                setGettingLocation(false);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };

    // End Fetch Office Location

    const UpdatemyProfile = async () => {


        setError(false);
        setSuccess(false);

        if (!name || !companyName || !phone) {
            setError(true);
            return;
        }

        try {

            setLoading(true);

            const user = JSON.parse(localStorage.getItem("user"));
            const token = JSON.parse(localStorage.getItem("token"));

            const userId = user?._id || user;

            const response = await fetch(
                `${API_URL}/users/${userId}`,
                {
                    method: "PUT",

                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },

                    body: JSON.stringify({
                        name,

                        planType,
                        companyName,
                        logo,

                        phone,
                        whatsapp,

                        checkinTime,
                        checkoutTime,

                        locationRadius,

                        timezone,

                        longitude,
                        latitude
                    })
                }
            );

            const data = await response.json();

            if (response.ok) {

                setSuccess(true);

            } else {
                alert(data.result || "Profile update failed");
            }

        } catch (error) {

            console.log(error);
            alert("Something went wrong");

        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        GetUserProfile();
    }, []);


    const GetUserProfile = async () => {

        try {

            const user = JSON.parse(localStorage.getItem("user"));
            const token = JSON.parse(localStorage.getItem("token"));

            const userId = user?._id || user;

            console.log('ID', userId);

            const response = await fetch(
                `${API_URL}/users/${userId}`,
                {
                    method: "GET",
                    headers: {
                        authorization: `bearer ${token}`
                    }
                }
            );

            const data = await response.json();

            if (response.ok && data.user) {

                const userData = data.user;

                setName(userData.name || "");
                setEmail(userData.email || "");
                setPlanType(userData.planType || "Free");

                setCompanyName(userData.companyName || "");
                setLogo(userData.logo || "");

                setPhone(userData.phone || "");
                setWhatsapp(userData.whatsapp || "");

                setCheckinTime(userData.checkinTime || "");
                setCheckoutTime(userData.checkoutTime || "");


                 setLocationRadius(userData.locationRadius || "");

                setLongitude(userData.longitude || "");
                setLatitude(userData.latitude || "");
                setTimezone(userData.timezone || "");
            }

        } catch (error) {

            console.log("Profile Error:", error);

        }
    };



    return (

        <div className="content">

            <main className="page-content p-4">

                <div className="card shadow-sm mb-4">

                    <div className="card-body">

                        <h2>Update Profile</h2>

                        <p className="text-muted">
                            Update your account and company information.
                        </p>

                        {success && (
                            <div className="alert alert-success" role="alert">
                                <strong>Success!</strong> Your profile has been updated successfully.
                            </div>
                        )}

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                Please fill all required fields.
                            </div>
                        )}

                        <div className="row g-4">

                            {/* Name */}
                            <div className="col-lg-6">
                                <label className="form-label">
                                    Name <span className="text-danger">*</span>
                                </label>

                                <input
                                    className="form-control"
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Your Name"
                                />

                                {error && !name && (
                                    <span className="error_msg">
                                        Please enter your name
                                    </span>
                                )}
                            </div>


                            {/* Email */}
                            <div className="col-lg-6">
                                <label className="form-label">
                                    Email <span className="text-danger">You Cant Change</span>
                                </label>

                                <div className="form-control" >{email}</div>

                            </div>



                            {/* Plan Type */}
                            <div className="col-lg-6">
                                <label className="form-label">
                                    Plan Type
                                </label>

                                <select
                                    className="form-control"
                                    value={planType}
                                    onChange={(e) => setPlanType(e.target.value)}
                                >
                                    <option value="Free">Free</option>
                                </select>
                            </div>


                            {/* Company Name */}
                            <div className="col-lg-6">
                                <label className="form-label">
                                    Company Name <span className="text-danger">*</span>
                                </label>

                                <input
                                    className="form-control"
                                    type="text"
                                    value={companyName}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                    placeholder="Enter Company Name"
                                />

                                {error && !companyName && (
                                    <span className="error_msg">
                                        Please enter company name
                                    </span>
                                )}
                            </div>


                            {/* Logo */}
                            <div className="col-lg-6">
                                <div className="logo-upload">

                                    <label>Company Logo</label>

                                    <input
                                        type="file"
                                        accept="image/png,image/jpeg,image/jpg,image/webp"
                                        onChange={handleLogoUpload}
                                    />

                                    {logo && (
                                        <div style={{ marginTop: "15px" }}>

                                            <div
                                                style={{
                                                    width: "200px",
                                                    height: "150px",
                                                    border: "1px solid #ddd",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    overflow: "hidden"
                                                }}
                                            >
                                                <img
                                                    src={logo}
                                                    alt="Company Logo"
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: "100%",
                                                        transform: `scale(${logoScale / 100})`,
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </div>

                                            <div style={{ marginTop: "10px" }}>
                                                <label>Logo Size: {logoScale}%</label>

                                                <input
                                                    type="range"
                                                    min="50"
                                                    max="150"
                                                    value={logoScale}
                                                    onChange={(e) =>
                                                        setLogoScale(Number(e.target.value))
                                                    }
                                                />
                                            </div>

                                        </div>
                                    )}

                                </div>


                            </div>


                            {/* Phone */}
                            <div className="col-lg-6">
                                <label className="form-label">
                                    Phone Number <span className="text-danger">*</span>
                                </label>

                                <input
                                    className="form-control"
                                    type="tel"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    placeholder="Enter Phone Number"
                                />

                                {error && !phone && (
                                    <span className="error_msg">
                                        Please enter phone number
                                    </span>
                                )}
                            </div>


                            {/* WhatsApp */}
                            <div className="col-lg-6">
                                <label className="form-label">
                                    WhatsApp Number
                                </label>

                                <input
                                    className="form-control"
                                    type="tel"
                                    value={whatsapp}
                                    onChange={(e) => setWhatsapp(e.target.value)}
                                    placeholder="Enter WhatsApp Number"
                                />
                            </div>


                            {/* Checkin */}
                            <div className="col-lg-6">
                                <label className="form-label">
                                    Check-in Time
                                </label>

                                <input
                                    className="form-control"
                                    type="time"
                                    value={checkinTime}
                                    onChange={(e) => setCheckinTime(e.target.value)}
                                />
                            </div>


                            {/* Checkout */}
                            <div className="col-lg-6">
                                <label className="form-label">
                                    Check-out Time
                                </label>

                                <input
                                    className="form-control"
                                    type="time"
                                    value={checkoutTime}
                                    onChange={(e) => setCheckoutTime(e.target.value)}
                                />
                            </div>



                            <div className="col-lg-6">
                                <label className="form-label">
                                    Select Time Zone
                                </label>

                                <select  className="form-control" value={timezone}
                                        onChange={(e) => setTimezone(e.target.value)}>
                                    <option>Asia/Kolkata</option>
                                    <option>America/New_York</option>
                                    <option>America/Los_Angeles</option>
                                    <option>Europe/London</option>
                                    <option>Asia/Dubai</option>
                                    <option>Asia/Singapore</option>
                                    <option>Australia/Sydney</option>
                                </select>
                            </div>

                            

                            <hr></hr>

                            <div className="row align-items-end justify-content-end">
                                {/* Longitude */}
                                <div className="col-lg-5">
                                    <label className="form-label">
                                        Longitude
                                    </label>

                                    <input
                                        className="form-control"
                                        type="number"
                                        step="any"
                                        value={longitude}
                                        onChange={(e) => setLongitude(e.target.value)}
                                        placeholder="Enter Longitude"
                                    />


                                </div>


                                {/* Latitude */}
                                <div className="col-lg-5">
                                    <label className="form-label">
                                        Latitude
                                    </label>

                                    <input
                                        className="form-control"
                                        type="number"
                                        step="any"
                                        value={latitude}
                                        onChange={(e) => setLatitude(e.target.value)}
                                        placeholder="Enter Latitude"
                                    />

                                </div>



                                <div className="col-lg-2">
                                    <button type="button" className="btn btn-sm btn-primary" onClick={copyLocation} disabled={gettingLocation}>
                                        {gettingLocation ? "Waiting..." : "Update Location"}
                                    </button>

                                    {Updated && (
                                        <span style={{ marginLeft: "10px" }}>
                                            Updated!
                                        </span>
                                    )}

                                </div>
                            </div>



                            <hr></hr>


 <div className="row align-items-center justify-content-center">
 <div className="col-lg-6">
    <label className="form-label fw-semibold">
        Location Radius
    </label>

    <div className="d-flex align-items-center gap-3">
        <input
            type="range"
            className="form-range"
            min="50"
            max="250"
            step="1"
            value={locationRadius}
            onChange={(e) => setLocationRadius(Number(e.target.value))}
        />

        <span className="fw-bold text-primary" style={{ minWidth: "70px" }}>
            {locationRadius}M
        </span>
    </div>

    <div className="d-flex justify-content-between small text-muted">
        <span>50 Meter</span>
        <span>250 Meter</span>
    </div>
</div>

</div>



                            {/* Button */}
                            <div className="col-lg-12 text-center mt-3">

                                <button
                                    type="button"
                                    onClick={UpdatemyProfile}
                                    className="btn btn-success px-5"
                                    disabled={loading}
                                >
                                    {loading ? "Updating..." : "Update Profile"}
                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            </main>

        </div>

    )


}

export default UpdateProfile;